module.exports = __webpack_public_path__ + "static/media/step3_14_m.e61581fb.png";